import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { useShallow } from "zustand/shallow";

import { useOfflineModeState } from "@src/states/offline_mode";
import { usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { DEFAULT_TRACK_ID } from "@src/services/player/constants";
import { StreamProxy } from "@src/services/streamProxy";

import { enterOfflineMode } from "@src/utils/offline/enterOfflineMode";
import { exitOfflineMode } from "@src/utils/offline/exitOfflineMode";

export function TestButtons() {
  const queryClient = useQueryClient();
  const [currentTrackObj, currentTrackId] = usePlayerState(
    useShallow((state) => [
      state.tracks[state.currentTrackId],
      state.currentTrackId,
    ]),
  );
  const cachedUrls = useOfflineModeState((state) => state.cachedUrls);

  const testSentry = (
    <button
      type="button"
      onClick={() => {
        throw new Error("This is your first error!");
      }}
    >
      Testar Sentry
    </button>
  );

  const isOnlinePlaying = currentTrackId === DEFAULT_TRACK_ID;
  const hasProxy = useMemo(
    () => StreamProxy.hasProxy(currentTrackObj?.url),
    [currentTrackObj?.url],
  );
  const testProxy = (
    <button
      type="button"
      onClick={() => {
        const currentUrl = currentTrackObj?.url;
        if (isOnlinePlaying && currentUrl) {
          const newUrl = StreamProxy.toggleProxy(currentUrl);
          player.removeTrack(DEFAULT_TRACK_ID).then(() => {
            player.addTrack(DEFAULT_TRACK_ID, newUrl, true);
            player.play(DEFAULT_TRACK_ID);
          });
        } else {
          alert("Você precisa estar escutando a rádio online.");
        }
      }}
    >
      {hasProxy ? "Desativar proxy" : "Ativar proxy"}
    </button>
  );

  if (isOnlinePlaying && cachedUrls.size >= 1) {
    return (
      <>
        {testProxy}
        {testSentry}
        <button
          type="button"
          onClick={() => {
            useOfflineModeState.setState({
              enableConnectionMonitor: false,
              isOnline: false,
            });
            enterOfflineMode(queryClient, "F");
          }}
        >
          Entrar no modo offline
        </button>
      </>
    );
  }

  const isOfflinePlaying = currentTrackId === "offline";
  if (isOfflinePlaying) {
    return (
      <>
        {testProxy}
        {testSentry}
        <button
          type="button"
          onClick={() => {
            enterOfflineMode(queryClient, "G");
          }}
        >
          Próxima música
        </button>
        <button
          type="button"
          onClick={() => {
            player.seekToLastFiveSeconds("offline");
          }}
        >
          Avançar para o final da música
        </button>
        <button
          type="button"
          onClick={() => {
            useOfflineModeState.setState({
              enableConnectionMonitor: true,
              isOnline: true,
            });
            exitOfflineMode(
              player.getPlayingOrPaused(currentTrackId),
              queryClient,
            );
          }}
        >
          Sair do modo offline
        </button>
      </>
    );
  }

  return (
    <>
      {testProxy}
      {testSentry}
    </>
  );
}
